import { gql } from '@apollo/client';

import {
  AddFormInsightDocument,
  type AddFormInsightMutation,
  type AddFormInsightMutationVariables,
} from '../__generated__/documents';

if (false) {
  gql`
    mutation AddFormInsight($input: AddFormInsightInput!) {
      addFormInsight(input: $input) {
        id
        progress
        shareId
        surveyId
        contact {
          id
          firstName
          lastName
          email
          phone
        }
        project {
          id
          title
          publicTitle
        }
      }
    }
  `;
}

export const ADD_FORM_INSIGHT = AddFormInsightDocument;
export type { AddFormInsightMutation, AddFormInsightMutationVariables };
